const httpCode = {
  success: 200,
  created: 201,
  notFound: 404,
  badRequest: 400,
  unauthorized: 401,
  forbidden: 403,
  conflict: 409,
  unprocessableEntity: 422,
  internalServerError: 500,
} as const;

export default httpCode;